import { ofType } from "redux-observable";
import { ajax } from "rxjs/ajax";
import { of } from "rxjs";
import { mergeMap, catchError, switchMap } from "rxjs/operators";
import ChartTypes from "../utils/ChartTypes";
import { FETCH_CONTENT_BEGIN, fetchContentSuccess, logError, fetchContentCanceled } from "../actions";
import sources from "../utils/JsonSources";
import { getAjaxSettings } from "../utils/getAjaxSettings";
export default function fetchContentEpic(action$, state$) {
    return action$.pipe(ofType(FETCH_CONTENT_BEGIN), mergeMap(function(action) {
        return !state$.value.contents[action.nodeId] ? ajax(getAjaxSettings("".concat(sources.chartPath, "/").concat(ChartTypes[action.nodeType].path, "/").concat(action.id, ".json"), state$.value)).pipe(switchMap(function(param) {
            var response = param.response;
            return [
                fetchContentSuccess({
                    content: response,
                    id: action.nodeId
                })
            ];
        }), catchError(function(error) {
            return of(logError({
                error: error,
                key: "fetch_content"
            }));
        })) : of(fetchContentCanceled());
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "fetch_content"
        }));
    }));
}
